import { render, staticRenderFns } from "./DetailsButton.vue?vue&type=template&id=e27248a8&scoped=true&"
import script from "./DetailsButton.vue?vue&type=script&lang=js&"
export * from "./DetailsButton.vue?vue&type=script&lang=js&"
import style0 from "./DetailsButton.vue?vue&type=style&index=0&id=e27248a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e27248a8",
  null
  
)

export default component.exports